import { combineReducers } from 'redux';

// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { areasOfFocusReducer as areasOfFocus } from './ducks/areasOfFocus';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { contentsReducer as contents } from './ducks/contents';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { currentUserReducer as currentUser } from './ducks/currentUser';
// TODO: Fix this the next time the file is edited.
import { errorReducer as error } from './ducks/error';
import { flashMessagesReducer as flashMessages } from './ducks/flashMessages';
import { gMapsErrorReducer as gMapsError } from './ducks/gMapsError';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { gradSchoolsReducer as gradSchools } from './ducks/gradSchools';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { internshipFunctionsReducer as internshipFunctions } from './ducks/internshipFunctions';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { invitesReducer as invites } from './ducks/invites';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { invoicesReducer as invoices } from './ducks/invoices';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { jobFunctionsReducer as jobFunctions } from './ducks/jobFunctions';
import { layoutReducer as layout } from './ducks/layout';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { listingsReducer as listings } from './ducks/listings';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { mainSearchReducer as mainSearch } from './ducks/mainSearch';
import { modalReducer as modal } from './ducks/modal';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { orgDashboardReducer as orgDashboard } from './ducks/orgDashboard';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { paymentMethodsReducer as paymentMethods } from './ducks/paymentMethods';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { postSearchReducer as postSearch } from './ducks/postSearch';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { searchRadiusReducer as searchRadius } from './ducks/searchRadius';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { subscribedSubsitesReducer as subscribedSubsites } from './ducks/subscribedSubsites';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { userLocationReducer as userLocation } from './ducks/userLocation';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { userNotificationsReducer as userNotifications } from './ducks/userNotifications';
// TODO: Fix this the next time the file is edited.
// eslint-disable-next-line import/no-cycle
import { volopFunctionsReducer as volopFunctions } from './ducks/volopFunctions';
import { reducer as orgs } from './slices/orgs';

const reducers = {
  error,
  gMapsError,
  currentUser,
  userNotifications,
  userLocation,
  paymentMethods,
  invites,
  areasOfFocus,
  jobFunctions,
  internshipFunctions,
  volopFunctions,
  orgs,
  listings,
  mainSearch,
  modal,
  layout,
  searchRadius,
  flashMessages,
  orgDashboard,
  invoices,
  contents,
  postSearch,
  gradSchools,
  subscribedSubsites,
};

export type Reducers = typeof reducers;

export const mainRootReducer = combineReducers(reducers);
